import { useParams } from "react-router-dom";
import {
    RightHeadDecoration,
    LeftHeadDecoration,
} from "../../../../../styles/main/MainCommonStyles";
import { CFlex, CMargin, DText, Flex } from "../../../../../styles/CommonStyles";
import DetailsLayout from "../../../../layout/main/DetailsLayout";
import { TradeTypeBadge } from "../../../../../styles/main/orders";
import { formatDate } from "../../../../../core/utils/common";
import { useMainContext } from "../../../../../core/contexts/main";
import { useGetACard } from "../../../../../core/services/react-query/report/cards";
import CoinRow from "../../../../common/common/CoinRow";

const CardDetails = () => {

    const { lang } = useMainContext();
    const params = useParams();

    const {
        data: card,
        isFetching,
        isError
    } = useGetACard(params.detailId);

    return (
        <DetailsLayout
            isFetching={isFetching}
            isError={isError}
        >

            <RightHeadDecoration>
                <CoinRow
                    coin={{ id: card?.meta?.currency?.toLowerCase() }}
                />
            </RightHeadDecoration>

            <LeftHeadDecoration left="10px">
                <DText main>
                    **** {card?.lastFour}
                </DText>
            </LeftHeadDecoration>

            <DText fontSize="b" primary >
                {card?.meta?.currency} Virtual Card
            </DText>

            <Flex justify="space-between" wrap>

                <CFlex width="100%" style={{ minWidth: "320px", gap: "6px" }}>

                    <CMargin margin="8px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>User</DText>
                        <DText primary>{card?.user?.email}</DText>
                    </Flex>

                    <CMargin margin="6px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>Card Holder</DText>
                        <DText primary>{card?.meta?.userName}</DText>
                    </Flex>

                    <CMargin margin="6px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>Provider</DText>
                        <DText primary>{card?.provider}</DText>
                    </Flex>

                    <CMargin margin="6px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>Type</DText>

                        <TradeTypeBadge color="primary">
                            {card?.type}
                        </TradeTypeBadge>
                    </Flex>

                    <CMargin margin="6px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>Status</DText>

                        <TradeTypeBadge
                            color={
                                card?.status === "success"
                                    ? "success"
                                    : card?.status === "pending"
                                        ? "warning"
                                        : "danger"
                            }
                        >
                            {card?.status}
                        </TradeTypeBadge>
                    </Flex>

                    <CMargin margin="6px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>Currency</DText>
                        <DText primary>{card?.meta?.currency}</DText>
                    </Flex>

                    <CMargin margin="6px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>Last 4</DText>
                        <DText primary>{card?.lastFour}</DText>
                    </Flex>

                    <CMargin margin="6px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>BIN</DText>
                        <DText primary>{card?.meta?.bin}</DText>
                    </Flex>

                    <CMargin margin="6px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>Card Mode</DText>
                        <DText primary>{card?.meta?.cardMode}</DText>
                    </Flex>

                    <CMargin margin="6px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>Label</DText>
                        <DText primary>{card?.meta?.label}</DText>
                    </Flex>


                    <CMargin margin="8px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>Reference ID</DText>
                        <DText primary>{card?.referenceId}</DText>
                    </Flex>

                    <CMargin margin="6px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>Account ID</DText>
                        <DText primary>{card?.meta?.accountId}</DText>
                    </Flex>

                    <CMargin margin="6px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>Balance ID</DText>
                        <DText primary>{card?.meta?.balanceId}</DText>
                    </Flex>

                    <CMargin margin="6px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>Budget ID</DText>
                        <DText primary>{card?.meta?.budgetId}</DText>
                    </Flex>

                    <CMargin margin="6px" />

                    <Flex fw style={{ flexDirection: 'row-reverse' }} justify="space-between">
                        <DText primary>Billing Address</DText>
                        <DText
                            primary
                            style={{
                                textAlign: "right",
                                maxWidth: "260px",
                                wordBreak: "break-word"
                            }}
                        >
                            {card?.meta?.billingAddress?.addressLine1}
                        </DText>
                    </Flex>

                </CFlex>
            </Flex>

            <Flex
                fw
                justify="space-between"
                style={{ marginTop: 20 }}
            >
                <DText main>
                    {formatDate(card?.createdAt, "date", lang)}
                </DText>

                <DText main>
                    {formatDate(card?.createdAt, "time", lang)}
                </DText>
            </Flex>

        </DetailsLayout>
    );
};

export default CardDetails;